export function getCaption(typ, t) {
    return t(`enums.${typ}`);
}
